import React from 'react'

const CricketChart = () => {
    return (
        <>
            <div className="col-md-3">
                <div className="update-bx">
                    <h3>Live Cricket</h3>
                    <div className="p-3">
                        <table className="table text-center table-borderless">
                            <tbody>
                                <tr>
                                    <th>India</th>
                                    <th>VS</th>
                                    <th>Pakistan</th>
                                </tr>
                                <tr>
                                    <td>210/9 (50)</td>
                                    <td>&nbsp;</td>
                                    <td>130/6(40.5)</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <span className="close-btn d-none">
                        <i className="fa fa-times-circle-o" />
                    </span>
                </div>
            </div>
        </>
    )
}

export default CricketChart